// extracted by mini-css-extract-plugin
export default {"step_card_wrapper":"balls-game-instruction_step_card_wrapper__UB4mx","card_image_wrapper":"balls-game-instruction_card_image_wrapper__dJz6j"};